import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { OrganizationPage } from "~/pages/organization/organization.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/organization",
)({
  // `slack` is set by the `/api/slack/callback` redirect so the page can toast
  // the outcome of the Slack workspace OAuth install.
  validateSearch: z.object({ slack: z.string().optional() }),
  component: OrganizationPage,
});
